// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tag-item .el-menu-item[data-v-3ece4f7e] {\n  height: 20px;\n  font-size: 11px;\n  text-indent: 40px;\n  line-height: 1.75;\n}\n", ""]);
// Exports
module.exports = exports;
